import * as angular from "angular";
import * as _ from "lodash";
import {PricePlanBundleRequestsService} from "./services/price-plan-bundle-requests.service";
import {PricePlanRequestsService} from "./services/price-plan-requests.service";
import {PricePlanBundleService} from "./services/price-plan-bundle.service";
import {SplitService} from "../commons/services/split-service.service";
import {PROGRAM_IMPORT_TYPES} from "./constants/program-import.const";


angular
  .module('bringoz.admin.pricePlan')
  .config(PricePlanConfig);

/* @ngInject */
function PricePlanConfig($stateProvider) {
  $stateProvider

    .state('pricePlans-templates', {
      parent: 'bringoz.site',
      url: '/pricePlan-templates/:programType',
      controllerAs: 'vm',
      template: '<program-templates-view program-types="vm.programTypes" ' +
        'selected-program-type="vm.selectedProgramType"></program-templates-view>',
      controller: function (splitService, site, $stateParams, triBreadcrumbsService) {
        this.programTypes = _.sortBy(_.map(splitService.getSiteProgramTypesMap(), function (value, key) {
          return {id: key, type: value};
        }), 'id');

        this.selectedProgramType = $stateParams.programType;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Program Templates'});
        triBreadcrumbsService.addCrumb({name: "Operations Management"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      }
    })

    // Template Program Views
    .state('pricePlans-templates.template', {
      abstract: true,
      url: '/:programId',
      reloadOnSearch: false,
      controllerAs: 'vm',
      template: '<program-template-details-view selected-program-id="vm.programId"></program-template-details-view>',
      controller: function (triBreadcrumbsService, site, $stateParams) {
        this.programId = $stateParams.programId;
      }
    })
    .state('pricePlans-templates.template.service', {
      url: '/plan',
      views: {
        'pricePlanDetailsSub': {
          template: '<program-pricing-method-view flex program-id="vm.programId" program-setting="vm.programSetting"></program-pricing-method-view>',
          controllerAs: 'vm',
          controller: function (site, $stateParams, pricePlanBundle, servicesProgramTypes) {
            this.programId = $stateParams.programId;

            const programEntry = _.find(pricePlanBundle.entryList, (p) => {
              return p.id === this.programId
            })
            this.programSetting = programEntry?.programSetting;
          },
          resolve: {
            servicesProgramTypes: function (site, pricePlanBundleRequestsService: PricePlanBundleRequestsService) {
              return pricePlanBundleRequestsService.getSiteServicesProgramType();
            }
          }
        }
      }
    })
    .state('pricePlans-templates.template.price', {
      url: '/pricing',
      views: {
        'pricePlanDetailsSub': {
          template: '<price-plan-pricing-view flex program="vm.program" groups="vm.groups" account-id="vm.accountId" program-id="vm.programId"></price-plan-pricing-view>',
          controllerAs: 'vm',
          controller: function (program, $stateParams) {
            this.groups = ['Pricing', 'Wait', 'Late', 'Accessorials', 'SpotDimensions'];
            this.program = program;
            this.programId = $stateParams.programId;
          },
          resolve: {
            program: function (pricePlanRequestsService: PricePlanRequestsService, $stateParams) {
              let groups = ['Pricing', 'Wait', 'Late', 'Accessorials', 'SpotDimensions'];
              return pricePlanRequestsService.getPricePlanPreferences($stateParams.programId, groups)
            }
          }
        }
      }
    })
    .state('pricePlans-templates.template.quantity', {
      url: '/quantity',
      pageTrack: '/account/demand/programs/quantity',
      views: {
        'pricePlanDetailsSub': {
          template: '<program-quantity-view flex program="vm.program" groups="vm.groups" program-id="vm.programId"></program-quantity-view>',
          controllerAs: 'vm',
          controller: function (program, $stateParams) {
            this.groups = ['QuantityDiscount'];
            this.program = program;
            this.accountId = $stateParams.id;
            this.programId = $stateParams.programId;
          },
          resolve: {
            program: function (pricePlanRequestsService: PricePlanRequestsService, $stateParams) {
              let groups = ['QuantityDiscount'];
              return pricePlanRequestsService.getPricePlanPreferences($stateParams.programId, groups)
            }
          }
        }
      }
    })
    .state('pricePlans-templates.template.vehicleCharge', {
      url: '/vehicle-charge',
      pageTrack: '/account/demand/programs/vehicle-charge',
      views: {
        'pricePlanDetailsSub': {
          template: '<price-plan-vehicle-charge-view flex program="vm.program" groups="vm.groups" program-id="vm.programId"></price-plan-vehicle-charge-view>',
          controllerAs: 'vm',
          controller: function (program, $stateParams, splitService: SplitService) {
            this.groups = splitService.getUseLegacyVehicleType() ? ['VehicleFactor'] : ['VehicleTypeFactor'];
            this.program = program;
            this.programId = $stateParams.programId;
          },
          resolve: {
            program: function (pricePlanRequestsService: PricePlanRequestsService, $stateParams, splitService: SplitService) {
              let groups = splitService.getUseLegacyVehicleType() ? ['VehicleFactor'] : ['VehicleTypeFactor'];
              return pricePlanRequestsService.getPricePlanPreferences($stateParams.programId, groups)
            }
          }
        }
      }
    })
    .state('pricePlans-templates.template.packageSize', {
      url: '/package-size',
      pageTrack: '/account/demand/programs/package-size',
      views: {
        'pricePlanDetailsSub': {
          template: '<price-plan-package-size-view flex '
            + 'program="vm.program" '
            + 'groups="vm.groups" '
            + 'program-id="vm.programId" '
            + 'label-options="vm.labels"></price-plan-package-size-view>',
          controllerAs: 'vm',
          controller: function (program, labels, $stateParams) {
            this.groups = ['PackageSize'];
            this.program = program;
            this.programId = $stateParams.programId;
            this.labels = labels;
          },
          resolve: {
            program: function (pricePlanRequestsService: PricePlanRequestsService, $stateParams) {
              let groups = ['PackageSize'];
              return pricePlanRequestsService.getPricePlanPreferences($stateParams.programId, groups)
            },
            labels: function (labelsRequestsService) {
              return labelsRequestsService.getAll();
            }
          }
        }
      }
    })
    .state('pricePlans-templates.template.pod', {
      url: '/pod',
      views: {
        'pricePlanDetailsSub': {
          template: '<program-pod-view flex program="vm.program" '
            + 'groups="vm.groups" '
            + 'program-id="vm.programId"></program-pod-view>',
          controllerAs: 'vm',
          controller: function (program, $stateParams) {
            this.groups = ['PickupPod', 'DropoffPod', 'OmsPickupPod', 'OmsDropoffPod'];
            this.program = program;
            this.programId = $stateParams.programId;
          },
          resolve: {
            program: function (pricePlanRequestsService: PricePlanRequestsService, $stateParams) {
              let groups = ['PickupPod', 'DropoffPod', 'OmsPickupPod', 'OmsDropoffPod'];
              return pricePlanRequestsService.getPricePlanPreferences(
                $stateParams.programId,
                groups
              );
            }
          }
        }
      }
    })
    .state('pricePlans-templates.template.additions', {
      url: '/additions',
      views: {
        'pricePlanDetailsSub': {
          template: '<program-additions-view flex program="vm.program" '
            + 'groups="vm.groups" '
            + 'program-id="vm.programId" '
            + 'site-additions="vm.siteAdditions"></program-additions-view>',
          controllerAs: 'vm',
          controller: function (program, siteAdditions, $stateParams) {
            this.groups = ['Addition'];
            this.program = program;
            this.programId = $stateParams.programId;
            this.siteAdditions = siteAdditions;
          },
          resolve: {
            program: function (pricePlanRequestsService: PricePlanRequestsService, $stateParams) {
              let groups = ['Addition'];
              return pricePlanRequestsService.getPricePlanPreferences(
                $stateParams.programId,
                groups
              );
            },
            siteAdditions: function (pricePlanBundleRequestsService: PricePlanBundleRequestsService) {
              return pricePlanBundleRequestsService.getSiteAdditions();
            }
          }
        }
      }
    })
    .state('pricePlans-templates.template.sub-tasks', {
      url: '/sub-tasks',
      views: {
        'pricePlanDetailsSub': {
          template: '<program-sub-tasks-view flex program="vm.program" '
            + 'groups="vm.groups" '
            + 'program-id="vm.programId"></program-sub-tasks-view>',
          controllerAs: 'vm',
          controller: function (program, $stateParams) {
            this.groups = ['SubTasks'];
            this.program = program;
            this.programId = $stateParams.programId;
          },
          resolve: {
            program: function (pricePlanRequestsService: PricePlanRequestsService, $stateParams) {
              let groups = ['SubTasks'];
              return pricePlanRequestsService.getPricePlanPreferences(
                $stateParams.programId,
                groups
              );
            }
          }
        }
      }
    })
    .state('pricePlans-templates.template.agent-validations', {
      url: '/agent-validations',
      views: {
        'pricePlanDetailsSub': {
          template: '<program-agent-validations-view flex program="vm.program" '
            + 'groups="vm.groups" '
            + 'program-id="vm.programId" site-service-validations="vm.siteServiceValidations"></program-agent-validations-view>',
          controllerAs: 'vm',
          controller: function (program, $stateParams, siteServiceValidations) {
            this.groups = ['ServiceValidation'];
            this.program = program;
            this.programId = $stateParams.programId;
            this.siteServiceValidations = siteServiceValidations;
          },
          resolve: {
            program: function (pricePlanRequestsService: PricePlanRequestsService, $stateParams) {
              let groups = ['ServiceValidation'];
              return pricePlanRequestsService.getPricePlanPreferences(
                $stateParams.programId,
                groups
              );
            },
            siteServiceValidations: function (pricePlanBundleService: PricePlanBundleService) {
              return pricePlanBundleService.getServiceValidations()
            }
          }
        }
      }
    })
    .state('pricePlans-templates.template.skills', {
      url: '/skills',
      views: {
        'pricePlanDetailsSub': {
          template: '<program-skills-view flex program="vm.program" '
            + 'groups="vm.groups" '
            + 'program-id="vm.programId"></program-skills-view>',
          controllerAs: 'vm',
          controller: function (program, $stateParams) {
            this.groups = ['Skills'];
            this.program = program;
            this.programId = $stateParams.programId;
          },
          resolve: {
            program: function (pricePlanRequestsService: PricePlanRequestsService, $stateParams) {
              let groups = ['Skills'];
              return pricePlanRequestsService.getPricePlanPreferences(
                $stateParams.programId,
                groups
              );
            }
          }
        }
      }
    })
    .state('pricePlans-templates.template.service-time', {
      url: '/service-time',
      views: {
        'pricePlanDetailsSub': {
          template: '<program-service-time-view flex program="vm.program" '
            + 'groups="vm.groups" '
            + 'program-id="vm.programId" is-show-field-service-card="true" is-show-allowed-waiting-card="true"></program-service-time-view>',
          controllerAs: 'vm',
          controller: function (program, $stateParams) {
            this.groups = ['Additional'];
            this.program = program;
            this.programId = $stateParams.programId;
          },
          resolve: {
            program: function (pricePlanRequestsService: PricePlanRequestsService, $stateParams) {
              let groups = ['Additional'];
              return pricePlanRequestsService.getPricePlanPreferences($stateParams.programId, groups)
            }
          }
        }
      }
    })
    .state('pricePlans-templates.template.scheduling', {
      url: '/urgency-charge',
      pageTrack: '/account/demand/programs/urgency-charge',
      views: {
        'pricePlanDetailsSub': {
          template: '<price-plan-urgency-charge-view flex program="vm.program" groups="vm.groups" program-id="vm.programId"></price-plan-urgency-charge-view>',
          controllerAs: 'vm',
          controller: function (program, $stateParams) {
            this.groups = ['UrgencySwitch', 'DynamicQuote', 'TimeSlot', 'UrgencyCharge', 'SchedulingPriority', 'DeliveryDaysIndication'];
            this.program = program;
            this.programId = $stateParams.programId;
          },
          resolve: {
            program: function (pricePlanRequestsService: PricePlanRequestsService, $stateParams) {
              let groups = ['UrgencySwitch', 'DynamicQuote', 'TimeSlot', 'UrgencyCharge', 'SchedulingPriority', 'DeliveryDaysIndication'];
              return pricePlanRequestsService.getPricePlanPreferences($stateParams.programId, groups)
            }
          }
        }
      }
    })
    .state('pricePlans-templates.template.calendar', {
      url: '/calendar',
      pageTrack: '/account/demand/programs/calendar',
      views: {
        'pricePlanDetailsSub': {
          template: '<price-plan-calendar program-id="vm.programId"></price-plan-calendar>',
          controllerAs: 'vm',
          controller: function ($stateParams) {
            this.programId = $stateParams.programId
          }
        }
      }
    })
    .state('pricePlans', {
      parent: 'bringoz.site',
      url: '/pricePlan',
      controllerAs: 'vm',
      template: '<app-price-plan-bundle-state-view [price-plans-bundle-hierarchy]="vm.pricePlansBundleHierarchy" [selected-price-plan-id]="vm.selectedPricePlanId"></app-price-plan-bundle-state-view>',
      controller: function (triBreadcrumbsService, pricePlansBundleHierarchy, selectedPricePlanId, site) {
        this.pricePlansBundleHierarchy = pricePlansBundleHierarchy;
        this.selectedPricePlanId = selectedPricePlanId;
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Programs'});
        triBreadcrumbsService.addCrumb({name: "Operations Management"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      },
      resolve: {
        pricePlansBundleHierarchy: function (pricePlanBundleRequestsService: PricePlanBundleRequestsService, $stateParams, site) {
          return pricePlanBundleRequestsService.getHierarchy();
        },
        selectedPricePlanId: function (pricePlansBundleHierarchy, site) {
          function findDefaultId(pricePlansBundleHierarchy) {
            let defaultElement = null;

            function recursiveSearch(items) {
              for (const item of items) {
                if (item.default) {
                  defaultElement = item;
                  return true;
                }
                if (item.children) {
                  if (recursiveSearch(item.children)) {
                    return true;
                  }
                }
              }
              return false;
            }

            recursiveSearch(pricePlansBundleHierarchy);
            return defaultElement ? defaultElement.id : null;
          }


          return findDefaultId(pricePlansBundleHierarchy);
        }
      }
    })

    // Import Program Settings (PRD-1726)
    .state('pricePlans-import', {
      parent: 'bringoz.site',
      url: '/pricePlan/import?:type',
      controllerAs: 'vm',
      template: '<program-import-view permission permission-only="vm.importType.permissions" ' +
        'import-type-id="vm.importTypeId"></program-import-view>',
      controller: function (triBreadcrumbsService, $state, $stateParams, IAMPermissions) {
        const importType = _.find(PROGRAM_IMPORT_TYPES, (type) => type.id === $stateParams.type)
          || _.head(PROGRAM_IMPORT_TYPES);
        const hasImportPermission = _.some(importType.permissions,
          (permission: string) => IAMPermissions.hasPermission(permission));

        if (!hasImportPermission) {
          $state.go('pricePlans');
          return;
        }

        this.importType = importType;
        this.importTypeId = importType.id;

        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Import Program Settings'});
        triBreadcrumbsService.addCrumb({name: 'Programs', state: 'pricePlans'});
        triBreadcrumbsService.addCrumb({name: "Operations Management"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      }
    })

    ////////////////////////////////////////////////////////////////////////////////////////////////////////////

    .state('pricePlanView', {
      parent: 'bringoz.site',
      url: '/bundle/:pricePlanBundleId?:programId',
      controllerAs: 'vm',
      abstract: true,
      template: '<billing-price-plan-view '
        + 'price-plan-bundle="vm.pricePlanBundle" '
        + 'selected-program-id="vm.programId"></billing-price-plan-view>',
      controller: function ($scope, pricePlanBundle, servicesProgramTypes, programId, triBreadcrumbsService, $stateParams, site) {

        this.pricePlanBundle = pricePlanBundle;
        this.programId = programId;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Bundle : ' + pricePlanBundle.id, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Programs', state: 'pricePlans'});
        triBreadcrumbsService.addCrumb({name: "Finance"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      },
      resolve: {
        pricePlanBundle: function (pricePlanBundleRequestsService: PricePlanBundleRequestsService, $stateParams, site) {
          return pricePlanBundleRequestsService.getBundleById($stateParams.pricePlanBundleId);
        },
        servicesProgramTypes: function (site, pricePlanBundleRequestsService: PricePlanBundleRequestsService) {
          return pricePlanBundleRequestsService.getSiteServicesProgramType();
        },
        programId: function ($stateParams, servicesProgramTypes, pricePlanBundle) {
          let programId;
          if (!!$stateParams.programId) {
            programId = $stateParams.programId;
          } else if (Object.keys(servicesProgramTypes).length) {
            const enabledProgramId = _.find(pricePlanBundle.entryList, p => {
              return p.type === servicesProgramTypes.Delivery && p.enabled;
            }).id;
            programId = !!enabledProgramId ? enabledProgramId : _.find(pricePlanBundle.entryList, (p) => p.enabled)?.id;
          } else {
            programId = _.find(pricePlanBundle.entryList, (p) => {
              return p.enabled;
            })?.id
          }

          return programId;
        }
      }
    })


    // Template Program Views
    .state('pricePlanView.details', {
      abstract: true,
      url: '/details',
      reloadOnSearch: false,
      controllerAs: 'vm',
      template: '<billing-price-plan-details selected-program-id="vm.selectedProgramId" price-plan-bundle="vm.pricePlanBundle"></billing-price-plan-details>',
      controller: function (triBreadcrumbsService, site, programId, pricePlanBundle, $stateParams) {
        this.pricePlanBundle = pricePlanBundle;
        this.selectedProgramId = programId;
      }
    })

    .state('pricePlanView.details.service', {
      url: '/service',
      views: {
        'pricePlanDetailsSub': {
          template: '<program-pricing-method-view flex program-id="vm.selectedProgramId" program-setting="vm.programSetting"></program-pricing-method-view>',
          controllerAs: 'vm',
          controller: function (site, $stateParams, pricePlanBundle, programId, servicesProgramTypes) {

            this.selectedProgramId = programId;

            const programEntry = _.find(pricePlanBundle.entryList, (p) => {
              return p.id === programId
            });
            this.programSetting = programEntry?.programSetting;
          },
        }
      }
    })


    .state('pricePlanView.details.price', {
      url: '/pricing',
      views: {
        'pricePlanDetailsSub': {
          template: '<price-plan-pricing-view flex program="vm.program" groups="vm.groups" program-id="vm.programId"></price-plan-pricing-view>',
          controllerAs: 'vm',
          controller: function (program, $stateParams) {
            this.groups = ['Pricing', 'Wait', 'Late', 'Accessorials', 'SpotDimensions'];
            this.program = program;
            this.programId = $stateParams.programId;
          },
          resolve: {
            program: function (pricePlanRequestsService: PricePlanRequestsService, $stateParams) {
              var groups = ['Pricing', 'Wait', 'Late', 'Accessorials', 'SpotDimensions'];
              return pricePlanRequestsService.getPricePlanPreferences($stateParams.programId, groups)
            }
          }
        }
      }
    })
    .state('pricePlanView.details.quantity', {
      url: '/quantity',
      views: {
        'pricePlanDetailsSub': {
          template: '<program-quantity-view flex program="vm.program" groups="vm.groups" program-id="vm.programId"></program-quantity-view>',
          controllerAs: 'vm',
          controller: function (program, $stateParams) {
            this.groups = ['QuantityDiscount'];
            this.program = program;
            this.programId = $stateParams.programId;
          },
          resolve: {
            program: function (pricePlanRequestsService: PricePlanRequestsService, $stateParams) {
              var groups = ['QuantityDiscount'];
              return pricePlanRequestsService.getPricePlanPreferences($stateParams.programId, groups)
            }
          }
        }
      }
    })
    .state('pricePlanView.details.vehicleCharge', {
      url: '/vehicle-charge',
      views: {
        'pricePlanDetailsSub': {
          template: '<price-plan-vehicle-charge-view flex program="vm.program" groups="vm.groups" program-id="vm.programId"></price-plan-vehicle-charge-view>',
          controllerAs: 'vm',
          controller: function (program, $stateParams, splitService: SplitService) {
            this.groups = splitService.getUseLegacyVehicleType() ? ['VehicleFactor'] : ['VehicleTypeFactor'];
            this.program = program;
            this.programId = $stateParams.programId;
          },
          resolve: {
            program: function (pricePlanRequestsService: PricePlanRequestsService, $stateParams, splitService: SplitService) {
              var groups = splitService.getUseLegacyVehicleType() ? ['VehicleFactor'] : ['VehicleTypeFactor'];
              return pricePlanRequestsService.getPricePlanPreferences($stateParams.programId, groups)
            }
          }
        }
      }
    })
    .state('pricePlanView.details.packageSize', {
      url: '/package-size',
      views: {
        'pricePlanDetailsSub': {
          template: '<price-plan-package-size-view flex program="vm.program" '
            + 'groups="vm.groups" '
            + 'program-id="vm.programId" '
            + 'label-options="vm.labels"></price-plan-package-size-view>',
          controllerAs: 'vm',
          controller: function (program, labels, $stateParams) {
            this.groups = ['PackageSize'];
            this.program = program;
            this.programId = $stateParams.programId;
            this.labels = labels;
          },
          resolve: {
            program: function (pricePlanRequestsService: PricePlanRequestsService, $stateParams) {
              var groups = ['PackageSize'];
              return pricePlanRequestsService.getPricePlanPreferences($stateParams.programId, groups)
            },
            labels: function (labelsRequestsService) {
              return labelsRequestsService.getAll();
            }
          }
        }
      }
    })
    .state('pricePlanView.details.pod', {
      url: '/pod',
      views: {
        'pricePlanDetailsSub': {
          template: '<program-pod-view flex program="vm.program" '
            + 'groups="vm.groups" '
            + 'program-id="vm.programId"></program-pod-view>',
          controllerAs: 'vm',
          controller: function (program, $stateParams) {
            this.groups = ['PickupPod', 'DropoffPod', 'OmsPickupPod', 'OmsDropoffPod'];
            this.program = program;
            this.programId = $stateParams.programId;
          },
          resolve: {
            program: function (pricePlanRequestsService: PricePlanRequestsService, $stateParams) {
              let groups = ['PickupPod', 'DropoffPod', 'OmsPickupPod', 'OmsDropoffPod'];
              return pricePlanRequestsService.getPricePlanPreferences($stateParams.programId, groups)
            }
          }
        }
      }
    })
    .state('pricePlanView.details.additions', {
      url: '/additions',
      views: {
        'pricePlanDetailsSub': {
          template: '<program-additions-view flex program="vm.program" '
            + 'groups="vm.groups" '
            + 'program-id="vm.programId" site-additions="vm.siteAdditions"></program-additions-view>',
          controllerAs: 'vm',
          controller: function (program, siteAdditions, $stateParams) {
            this.groups = ['Addition'];
            this.program = program;
            this.programId = $stateParams.programId;
            this.siteAdditions = siteAdditions;
          },
          resolve: {
            program: function (pricePlanRequestsService: PricePlanRequestsService, $stateParams) {
              var groups = ['Addition'];
              return pricePlanRequestsService.getPricePlanPreferences($stateParams.programId, groups)
            },
            siteAdditions: function (pricePlanBundleRequestsService: PricePlanBundleRequestsService) {
              return pricePlanBundleRequestsService.getSiteAdditions();
            }
          }
        }
      }
    })
    .state('pricePlanView.details.sub-tasks', {
      url: '/sub-tasks',
      views: {
        'pricePlanDetailsSub': {
          template: '<program-sub-tasks-view flex program="vm.program" '
            + 'groups="vm.groups" '
            + 'program-id="vm.programId"></program-sub-tasks-view>',
          controllerAs: 'vm',
          controller: function (program, $stateParams) {
            this.groups = ['SubTasks'];
            this.program = program;
            this.programId = $stateParams.programId;
          },
          resolve: {
            program: function (pricePlanRequestsService: PricePlanRequestsService, $stateParams) {
              var groups = ['SubTasks'];
              return pricePlanRequestsService.getPricePlanPreferences($stateParams.programId, groups)
            }
          }
        }
      }
    })

    .state('pricePlanView.details.agent-validations', {
      url: '/agent-validations',
      views: {
        'pricePlanDetailsSub': {
          template: '<program-agent-validations-view flex program="vm.program" '
            + 'groups="vm.groups" '
            + 'program-id="vm.programId" site-service-validations="vm.siteServiceValidations"></program-agent-validations-view>',
          controllerAs: 'vm',
          controller: function (program, $stateParams, siteServiceValidations) {
            this.groups = ['ServiceValidation'];
            this.program = program;
            this.programId = $stateParams.programId;
            this.siteServiceValidations = siteServiceValidations;
          },
          resolve: {
            program: function (pricePlanRequestsService: PricePlanRequestsService, $stateParams) {
              let groups = ['ServiceValidation'];
              return pricePlanRequestsService.getPricePlanPreferences(
                $stateParams.programId,
                groups
              );
            },
            siteServiceValidations: function (pricePlanBundleService: PricePlanBundleService) {
              return pricePlanBundleService.getServiceValidations()
            }
          }
        }
      }
    })
    .state('pricePlanView.details.skills', {
      url: '/skills',
      views: {
        'pricePlanDetailsSub': {
          template: '<program-skills-view flex program="vm.program" '
            + 'groups="vm.groups" '
            + 'program-id="vm.programId"></program-skills-view>',
          controllerAs: 'vm',
          controller: function (program, $stateParams) {
            this.groups = ['Skills'];
            this.program = program;
            this.programId = $stateParams.programId;
          },
          resolve: {
            program: function (pricePlanRequestsService: PricePlanRequestsService, $stateParams) {
              var groups = ['Skills'];
              return pricePlanRequestsService.getPricePlanPreferences($stateParams.programId, groups)
            }
          }
        }
      }
    })
    .state('pricePlanView.details.service-time', {
      url: '/service-time',
      views: {
        'pricePlanDetailsSub': {
          template: '<program-service-time-view flex program="vm.program" '
            + 'groups="vm.groups" '
            + 'program-id="vm.programId" is-show-field-service-card="true" is-show-allowed-waiting-card="true"></program-service-time-view>',
          controllerAs: 'vm',
          controller: function (program, $stateParams) {
            this.groups = ['Additional'];
            this.program = program;
            this.programId = $stateParams.programId;
          },
          resolve: {
            program: function (pricePlanRequestsService: PricePlanRequestsService, $stateParams) {
              var groups = ['Additional'];
              return pricePlanRequestsService.getPricePlanPreferences($stateParams.programId, groups)
            }
          }
        }
      }
    })
    .state('pricePlanView.details.scheduling', {
      url: '/scheduling-settings',
      views: {
        'pricePlanDetailsSub': {
          template: '<price-plan-urgency-charge-view flex program="vm.program" groups="vm.groups" program-id="vm.programId"></price-plan-urgency-charge-view>',
          controllerAs: 'vm',
          controller: function (program, $stateParams) {
            // this.groups = ['UrgencyCharge', 'UrgencySwitch', 'Additional'];
            this.groups = ['UrgencySwitch', 'DynamicQuote', 'TimeSlot', 'UrgencyCharge', 'SchedulingPriority', 'DeliveryDaysIndication'];
            this.program = program;
            this.programId = $stateParams.programId;
          },
          resolve: {
            program: function (pricePlanRequestsService: PricePlanRequestsService, $stateParams) {
              // var groups = ['UrgencyCharge', 'UrgencySwitch', 'Additional'];
              var groups = ['UrgencySwitch', 'DynamicQuote', 'TimeSlot', 'UrgencyCharge', 'SchedulingPriority', 'DeliveryDaysIndication'];
              return pricePlanRequestsService.getPricePlanPreferences($stateParams.programId, groups)
            }
          }
        }
      }
    })
    .state('pricePlanView.details.calendar', {
      url: '/calendar',
      views: {
        'pricePlanDetailsSub': {
          template: '<price-plan-calendar program-id="vm.programId"></price-plan-calendar>',
          controllerAs: 'vm',
          controller: function ($stateParams) {
            this.programId = $stateParams.programId
          }
          // templateUrl : 'app/modules/price-plan/components/calendar/calendar.tmpl.html',
          // controller : 'CalendarController'
        }
      }
    });

}
